import { IMRBaseComponent } from "../../../../../../../common/base"

import { OPERATOR_SECURITY_SERVICE_NAME } from "../../../../../../../../services/operator"
import { USER_SESSION_SERVICE_NAME } from "../../../../../../../../services/user-session"

import { OperatorDetailsSecurityRolesController } from "./operator-details.security.roles.controller"

//#region Asset Imports

import './operator-details.security.roles.scss'
import * as TEMPLATE from './operator-details.security.roles.tpl.html'

//#endregion

export const COMPONENT_NAME: string = 'operatorDetailsSecurityRoles'

export class OperatorDetailsSecurityRolesComponent extends IMRBaseComponent {

    constructor() {
        super({
            controller: OperatorDetailsSecurityRolesController,
            services: [OPERATOR_SECURITY_SERVICE_NAME, USER_SESSION_SERVICE_NAME],
            template: TEMPLATE
        })
    }
}